/* Keep the collapsed Zipchat launcher clear of mobile purchase controls. */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  let scheduled = false;
  let observedRoot;
  const rootObserver = new MutationObserver(schedule);
  const sizeObserver = new ResizeObserver(schedule);
  const observedControls = new WeakSet();
  const selector = '#MainContent #zakeke-product-button, #MainContent button[name="add"], #MainContent .shopify-payment-button';

  function overlaps(a, b) {
    return a.width > 0 && a.height > 0 && b.width > 0 && b.height > 0 &&
      a.left < b.right + 8 && a.right > b.left - 8 &&
      a.top < b.bottom + 8 && a.bottom > b.top - 8;
  }
  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }
  function update() {
    scheduled = false;
    const root = document.querySelector('#zipchat-shadow-host')?.shadowRoot;
    if (!root) return;
    if (root !== observedRoot) {
      rootObserver.disconnect();
      rootObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      observedRoot = root;
    }
    if (!root.querySelector('#jed-purchase-clearance-style')) {
      const style = document.createElement('style');
      style.id = 'jed-purchase-clearance-style';
      style.textContent = '.jed-purchase-overlap #widget-chat-button,.jed-purchase-overlap #chat-preview-message{visibility:hidden!important;pointer-events:none!important}';
      root.append(style);
    }
    const container = root.querySelector('#widget-chat-container');
    const bubble = root.querySelector('#widget-chat-button');
    const icon = root.querySelector('#bubble-icon');
    if (!container || !bubble || !icon) return;
    // An intentionally opened conversation must retain its close control.
    const isClosed = getComputedStyle(icon).display !== 'none';
    const controls = [...document.querySelectorAll(selector)];
    for (const control of controls) {
      if (!observedControls.has(control)) {
        sizeObserver.observe(control);
        observedControls.add(control);
      }
    }
    const preview = root.querySelector('#chat-preview-message');
    const floating = [bubble, preview].filter(e => e && getComputedStyle(e).display !== 'none');
    const collision = mobile.matches && isClosed && controls.some(control => {
      const style = getComputedStyle(control);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      const rect = control.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return false;
      return floating.some(e => overlaps(e.getBoundingClientRect(), rect));
    });
    container.classList.toggle('jed-purchase-overlap', collision);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
